import { ReactNode } from "react";

import { typography } from "@moodys/mdc-frontend.theming.mui-themes.typography.typography";
import { deepmerge } from "@mui/utils";

import { MoodysThemeProvider } from "@moodys/federated";
import { MoodysThemeProviderProps } from "@moodys/federated/types/theme/muiThemes/MoodysThemeProvider/MoodysThemeProvider";
import { useLayoutContext } from "components/Layout";
import { generateThemeOverrides } from "theme";

interface MoodysThemeProviderWhitneyProps extends MoodysThemeProviderProps {
  children: ReactNode;
}

const WHITNEY_TYPOGRAPHY = {
  typography: {
    fontFamily: typography.fontFamily,
    h1: {
      fontFamily: typography.fontFamily,
    },
    h2: {
      fontFamily: typography.fontFamily,
    },
    h3: {
      fontFamily: typography.fontFamily,
    },
    h4: {
      fontFamily: typography.fontFamily,
    },
    h5: {
      fontFamily: typography.fontFamily,
    },
    h6: {
      fontFamily: typography.fontFamily,
    },
    subtitle1: {
      fontFamily: typography.fontFamily,
    },
    subtitle2: {
      fontFamily: typography.fontFamily,
    },
    body1: {
      fontFamily: typography.fontFamily,
    },
    body2: {
      fontFamily: typography.fontFamily,
    },
    button: {
      fontFamily: typography.fontFamily,
    },
    caption: {
      fontFamily: typography.fontFamily,
    },
    overline: {
      fontFamily: typography.fontFamily,
    },
  },
};

export const MoodysThemeProviderWhitney = ({
  children,
  ...rest
}: MoodysThemeProviderWhitneyProps) => {
  const { themeMode } = useLayoutContext();

  const whitneyOverride = deepmerge(
    {
      ...WHITNEY_TYPOGRAPHY,
    },
    generateThemeOverrides({
      themeMode,
    })
  );

  return (
    <MoodysThemeProvider
      themeOverrides={whitneyOverride}
      colorPalette={themeMode === "dark" ? "mdcBlue" : "default"}
      {...rest}
    >
      {children}
    </MoodysThemeProvider>
  );
};
